import {compareStringsAlphabetically, filterObjectArray, flatten, mapValues, unique} from "../utils"

export type ReportData = MultiReportData | InstantReportData
export type MultiReportData = {data: FlatReportChartData | undefined, renderAs: "bar"|"line"}
export type InstantReportData = {data: ReportChartRow | undefined, renderAs: "pie"}
export type ReportChartData = { [axisPoint: string]: ReportChartRow }
export type ReportChartRow = { [dataId: string]: number /* being the count*/ }

export type InstantReportRunResult = ReportChartRow

export type FlatReportChartDataRow = {id: string, key: string, value: number}
export type FlatReportChartData = FlatReportChartDataRow[]

export const flattenReportChartData = (data: ReportChartData): FlatReportChartData =>
	flatten<FlatReportChartDataRow>(
		mapValues<ReportChartRow, FlatReportChartData, ReportChartData>(
			data,
			(row, key) => mapValues<number, FlatReportChartDataRow, ReportChartRow>(row, (value, id): FlatReportChartDataRow => ({id, key, value})))).sort((a, b) => compareStringsAlphabetically(a.key, b.key))

export const getActualData = (data: FlatReportChartData): FlatReportChartData => data.filter(d1 => d1.value != 0 || data.some(d2 => d1.id == d2.id && d2.value != 0))
export const getIds = (data: FlatReportChartData): string[] => unique(data.map(d => d.id))

export const getKeys = (data: FlatReportChartData): string[] => unique(data.map(d => d.key)).sort()

export const getDataById = (data: FlatReportChartData, id: string): FlatReportChartData => filterObjectArray(data, 'id', id)
export const getDataByKey = (data: FlatReportChartData, key: string): FlatReportChartData => filterObjectArray(data, 'key', key)




// WEBPACK FOOTER //
// ./src/lib/report-builder/chart-data.ts